import renderElement from './element';

export default renderElement.bind(null, 'span');




// WEBPACK FOOTER //
// ../~/idom-util/src/span.js